module.exports = __webpack_public_path__ + "images/img-2oe-tS-.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/ranks/3.jpg
// module id = 2036
// module chunks = 0